export default __webpack_public_path__ + "static/media/lotto2.bdcd8b20.jpg";